import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import DownloadIcon from "@mui/icons-material/FileDownloadOutlined";
import { Button } from "@mui/material";
import { useFilesContext } from "../FilesContext";

interface Props {
  selectedIds: string[];
}

const FilesGridHeaderToolbar = ({ selectedIds }: Props) => {
  const { onDownloadMultipleFiles, onDeleteMultipleFiles, hasPermissionsToManage } = useFilesContext();

  return (
    <>
      <Button
        onClick={() => onDownloadMultipleFiles(selectedIds)}
        color="secondary"
        variant="text"
        startIcon={<DownloadIcon />}
      >
        Download
      </Button>
      {hasPermissionsToManage && (
        <Button
          onClick={() => onDeleteMultipleFiles(selectedIds)}
          color="error"
          variant="text"
          startIcon={<DeleteIcon />}
        >
          Delete
        </Button>
      )}
    </>
  );
};

export default FilesGridHeaderToolbar;
